type Props = {
  title: string;
};

export function CareTeamProviderTitle({ title }: Props) {
  return <p className='text-experimental-forest font-medium text-base pt-16 pb-8'>{title}</p>;
}
